/*
  评卷聘用管理
*/
import request from "@/utils/request";

//获取评卷聘用管理页面参数
export function getParam() {
  return request({
    url: "/markteacher/markEmployMag/getParam",
    method: "get"
  });
}

//获取评卷聘用管理页面参数
export function getEmpolyNum(projectId) {
  let url = "/markteacher/markEmployMag/employTeacherNum";
  if(projectId){
    url += `?projectId=${projectId}`
  }
  return request({
    url,
    method: "get"
  });
}

//评卷聘用管理-省分页列表
export function getMarkEmployMag(params) {
  return request({
    url: "/markteacher/markEmployMag/getMarkEmployMag",
    method: "get",
    params
  });
}

//确认或作废聘用
export function updateEmployStatus(data) {
  return request({
    url: "/markteacher/markEmployMag/updateEmployStatus",
    method: "post",
    data
  });
}

//生成聘书
export function createOffer(data) {
  return request({
    url: "/markteacher/markEmployMag/createOffer",
    method: "post",
    data
  });
}

//开放查看
export function openCheck(data) {
  return request({
    url: "/markteacher/markEmployMag/openCheck",
    method: "post",
    data
  });
}

//正式发布聘用
export function formalReleaseEmploy(data) {
  return request({
    url: "/markteacher/markEmployMag/formalReleaseEmploy",
    method: "post",
    data
  });
}

// 打印聘书
export function printOffer(data) {
  return request({
    url: window.config.baseUrl4Shool + "/markteacher/markEmployMag/printOffer",
    method: "post",
    responseType: "blob", // 关键：声明响应类型为blob
    data
  });
}
